import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_portal-product_page_message_brand-click';

/**
 * An event that fires when a retailer clicks the message brand button on the product page. They may be in IDV in which case the message brand modal won't open and the retailer will be notified. This will be indicated in the event with an isMessagingAllowed param value of false.
 */
export function trackRetailerPortalProductPageMessageBrandClick(
  isMessagingAllowed: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { isMessagingAllowed },
  });
}
